<template>
    <div class="col-md-12 col-sm-12  p-0">

        <div class="d-flex col-12 p-0 mt-2 height-sm" >
            <b-col md="3" sm="12" class=" p-2 description">
                <div class="mt-2 header-text">
                    დამზღვევის ხელმოწერა
                    ან თანხმობა
                </div>
            </b-col>

            <b-col md="3" sm="12" class=" p-2 border-mn">
                <div class=" m-0 sm-width-sm">
                    <template v-if="this.$route.name === 'Contract' && this.returnDate != '' || this.$route.name === 'ContractGenerate'">
                        <div class="nino-mtavruli text-desc">სს პროკრედიტ ბანკი საქართველო</div>
                        <div class="text-desc border-bot font-size-sm"></div>
                        <div style="font-size:11px">
                        </div>
                    </template>
                </div>
            </b-col>
            <b-col md="3" sm="12" class=" p-2 description">
                <div class="mt-2 header-text">
                    მზღვეველის ხელმოწერა
                </div>
            </b-col>

            <b-col md="3" sm="12" class=" p-2 border-mn ">
                <div class="text-desc border-bot font-size-sm nino-mtavruli">JSC ARDI INSURANCE | სს არდი დაზღვევა</div>
                <div style="font-size:11px">
                </div>
            </b-col>
        </div>


        <div class="d-flex col-12 p-0 mt-2 height-sm">
            <b-col md="3" sm="12" class=" p-2 description">
                <div class="mt-2 ">
                    ხელმომწერი პირის სახელი და გვარი
                </div>
            </b-col>

            <b-col md="3" sm="12" class=" p-2 border-mn ">
                <div class="mt-2 ">
                    
                </div>
            </b-col>
            <b-col md="3" sm="12" class=" p-2 description">
                <div class="mt-2 ">
                    ხელმომწერი პირის სახელი და გვარი
                </div>
            </b-col>
            <b-col md="3" sm="12" class="border-mn p-0">
                <!--<img src="../../assets/img/signature_qamushadze.jpg" width="auto" height="65" class="pl-5">-->
                <img src="../../assets/img/Ardi_NewCode.png" width="auto" height="65" class="img-right">
            </b-col>
        </div>

        <template v-for="(item,index) in returnDate.clientlist" v-if="roleid != 2">
            <div class="col-6 p-0 mt-2 " :class="index % 2 != 0 ? 'pos-right' : 'pos-left'" >
                <div class="d-flex height-sm">
                    <b-col md="6" sm="12" class=" p-2 description">
                        <div class="mt-2 header-text mt-lg-2">
                            მსესხებელი {{index + 1}}
                            ხელმოწერა ან თანხმობა
                        </div>
                    </b-col>
                    <b-col md="6" sm="12" class=" p-2 border-mn">
                        <div class="mt-3 mt-lg-2"></div>
                    </b-col>
                </div>
                <div class="d-flex pt-2 height-sm">
                    <b-col md="6" sm="12" class=" p-2 description">
                        <div class="mt-lg-2">
                            ხელმომწერი პირის სახელი და გვარი
                        </div>
                    </b-col>
                    <b-col md="6" sm="12" class=" p-2 border-mn">
                        <div class="nino-mtavruli text-desc">{{item.mainEsignedPers}}</div>
                        <div class="text-desc border-bot font-size-sm"></div>
                        <div style="font-size:11px" class=""> </div>
                    </b-col>
                </div>
            </div>
        </template>
        <!--<template v-if="returnDate.clientlist.length % 2 != 0">
            <img src="../../assets/img/STAMP.png"  class="mt-2" id="img-content">
        </template>-->
    </div>
</template>

<script>
    export default {
        name: "Signature",
        props: ['roleid'],
        data() {
            return {
                serverDate: '',
                returnDate: '',
                controllerName: '',
            }
        },
        mounted() {
            this.$http.get("/policy/getdate").then((r) => {
                this.serverDate = r.data
            }).catch((e) => {
                console.log(e)
            })
            this.$http.get(`/policy/GetProListByCont/${this.$route.params.cont}/0`).then(r => {
                this.returnDate = r.data
                console.log("sig data", r.data);
            }).catch((e) => {
                console.log(e)
            })
        }
    }
</script>

<style scoped>

    @import "~bpg-nino-mtavruli";

    .nino-mtavruli {
        font-family: "BPG Nino Mtavruli", sans-serif;
    }

    .text-desc {
        font-weight: bold;
    }

    .border-bot {
        border-bottom: dashed #007960;
        width: 100%;
    }

    .img-right {
        float: right;
    }
    #img-content {
        float: right;
        height: 195px;
    }

    .description {
        background-color: #007961;
        color: #fff;
        font-size: 14px;
    }

    .header-text {
        font-weight: bold;
    }

    .border-mn {
        border: 1px solid #b0b1b3 !important;
        font-size: 14px;
    }

    .height-sm {
        height: 67px;
    }

    .pos-right {
        float: right
    }

    .pos-left {
        float: left
    }

    .vertical-center-sm {
        margin-top: 2rem !important;
    }


    @media (max-width: 500px) {
       #img-content {
            width: 245px;
            height: 216px;
        }
        .hide-logo-sm {
            display: none;
        }

        .height-sm {
            height: 135px;
        }

        .vertical-center-sm {
            margin-top: 6rem !important;
        }

        .logo-margintop {
            margin-top: 1.5rem !important;
        }
        .sm-width-sm{
            width:87px;
        }
    }
</style>